import BaseLayer from "./BaseLayer";
import {drawCircle, drawRectangle} from "../utils/map_utils";
import {fullColorHex, notNull} from "../../../utils/utils";

class CornerBlur extends BaseLayer {
    id = "corner-blur";
    label = "Corner Blur";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let widthOfRect = 0.15
        let {y_fields, img_type} = this.props.slide;
        let {ratioBlurCorner, rescanThresh, rescanThresh2, sporadicCells} = this.props;

        Object.entries(ratioBlurCorner).forEach(([key, imageKey]) => {
            let xc = parseInt(key.split('y')[0].split('x')[1]);
            let y = y_fields - parseInt(key.split('y')[1].split('.' + img_type)[0]);

            Object.entries(imageKey).forEach(([rawVal, val]) => {
                let x_shift = 0, y_shift = 0;
                switch (rawVal) {
                    case 'TOP':
                        x_shift = 0;
                        y_shift = widthOfRect;
                        break;
                    case 'LEFT':
                        x_shift = -widthOfRect;
                        break;
                    case 'TOP_LEFT':
                        x_shift = -widthOfRect;
                        y_shift = widthOfRect;
                        break;
                    default:
                        break;
                }
                this.process(val, xc, y, x_shift, y_shift, widthOfRect, rescanThresh, rescanThresh2);
            });
        });

        let min = 1.0, max = 0.0;
        notNull(sporadicCells) && Object.keys(sporadicCells).forEach(ck => {
            let avgDiff = sporadicCells[ck];
            max = Math.max(max, avgDiff);
            min = Math.min(min, avgDiff);
        })

        notNull(sporadicCells) && Object.keys(sporadicCells).forEach(ck => {
            let avgDiff = sporadicCells[ck];
            let xc = parseInt(ck.split('y')[0].split('x')[1]);
            let y = y_fields - parseInt(ck.split('y')[1].split('.' + img_type)[0]);
            this.processSporadic(ck, xc, y, (avgDiff - min) / (max - min), avgDiff);
        })

        resolve();
    });

    process = (val, xc, y, x_shift, y_shift, widthOfRect, rescanThresh, rescanThresh2) => {
        let {tile_width, tile_height, uperpixel} = this.props.slide;
        let display = false;
        let color;
        if (val < this.props.rescanThreshValue1) {
            color = "#FF0000" + "80";
            display = true;
        } else if (val < this.props.rescanThreshValue2) {
            color = "#FFA500" + "80";
            display = true;
        }
        let bounds = [
            [(xc + x_shift) * (tile_width * uperpixel), (y + y_shift) * (tile_height * uperpixel)],
            [(xc + x_shift + widthOfRect) * (tile_width * uperpixel), (y + y_shift) * (tile_height * uperpixel)],
            [(xc + x_shift + widthOfRect) * (tile_width * uperpixel), (y + y_shift - widthOfRect) *
            (tile_height * uperpixel)],
            [(xc + x_shift) * (tile_width * uperpixel), (y + y_shift - widthOfRect) * (tile_height * uperpixel)],
            [(xc + x_shift) * (tile_width * uperpixel), (y + y_shift) * (tile_height * uperpixel)],
        ]
        display && drawRectangle(bounds, this.layer.getSource(), true, 2, color, "", this.props.textColor);
    }

    processSporadic = (val, xc, y, scaleRatio, avgDiff) => {
        let {tile_width, tile_height, uperpixel} = this.props.slide;
        let p1 = (xc + 0.5) * tile_width * uperpixel;
        let p2 = (y - 0.5)* tile_height * uperpixel;
        let color = fullColorHex(255, 255-parseInt(255 * scaleRatio), 0);
        return drawCircle(p1, p2, 0.4 * tile_height * uperpixel, this.layer.getSource(), avgDiff.toFixed(2).toString(), 16,
            color, "Sporadic Cell: " + val, this.props.textColor);
    }
}

export default CornerBlur;
